// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8933) return "static/chunks/8933.9b731b16ca6e8ee5.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7172 ? "supabase" : chunkId) + "-" + {"6898":"ad173a18c97649c6","7172":"e4937f78daba9301"}[chunkId] + ".js";
};